<template>
    <el-dialog
      title="注意"
      :visible.sync="dialogVisible"
      width="50%"
      modal-append-to-selector='body' 
      append-to-selector="body"
      >
      <div >
        <div style="font-size: 16px;font-weight:bold;">
            <i class="el-icon-warning" style="color: #dca550; font-size: 18px"></i>
            以下店铺已关联默认品牌，是否跳过或解除原有关联后绑定新配置？
        </div>
        <div style="margin-top: 16px;">
          <span 
            v-for="(item,index) in (this.params.conflictingShopNames)"
            :key="index"
          >
            <el-image :src="PLATFORMS_ICONS[platform]" fit="fill" class="shop-img"></el-image>
            {{item}}
          </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSure('jump')">跳过</el-button>
        <el-button type="primary" @click="handleSure('bindNewSet')">绑定新配置</el-button>
      </span>
  </el-dialog>
  </template>
  
  <script>
  import { PLATFORMS_ICONS } from '@/dictionary/platforms';

  
  export default {
    data() {
      return {
        dialogVisible: false,
        params: {
            conflictingShopNames: []
        },
        type:'',
        cb:null,
        PLATFORMS_ICONS,
      }
    },
    inject:['platform'],
    methods: {
      method_open(params, cb) {
        this.dialogVisible = true;
        this.params = params;
        this.cb = cb
      },
      handleSure(type) {
        this.dialogVisible = false;
        this.type = type
        this.cb(type)
      }
    }
  
  }
  </script>
  
  <style lang="scss" scoped>
  .shop-img {
        height: 16px;
        vertical-align: middle;
    }
    
  </style>
  